import { RuleId, RuleLevel } from '../../../types-v2';
import { getAlternativeTextCardReason } from '../../../utils/get-alt-text-failure-reason';
export const staticAltTextRule = {
  checker: _ref => {
    let {
      images
    } = _ref;
    const failedElements = [];
    images.forEach(_ref2 => {
      let {
        id,
        alt,
        decorative,
        isLinked
      } = _ref2;
      const linkRequiresAlt = !!isLinked;
      const passesAsDecorative = !!decorative && !alt && !linkRequiresAlt;
      const failedReason = passesAsDecorative ? undefined : getAlternativeTextCardReason(alt);
      if (failedReason) {
        failedElements.push({
          failedReason,
          id
        });
      }
    });
    const status = failedElements.length === 0 ? 'passed' : 'failed';
    return {
      failedElements,
      status: images.length > 0 ? status : 'not-applicable'
    };
  },
  level: RuleLevel.Page,
  ruleId: RuleId.STATIC_ALT_TEXT
};
//# sourceMappingURL=static-alt-text.js.map